import Modal from './modal';
import Storage from './storage';
import RelatedCasesStore from './relatedCases';
import Calculator from './calculator';
import Cookies from './cookies';
import InsightsShorts from './insightsShorts';
import ExpertTalks from './expertTalks';
import StepsCalculator from './pricingCalculator';
import SearchStore from './searchStore';
import Tags from './tags';

export const cookies = new Cookies();
export const modal = new Modal();
export const tagsStore = new Tags();
export const storage = new Storage();
export const insightsShorts = new InsightsShorts();
export const expertTalks = new ExpertTalks();
export const pricingCalculator = new StepsCalculator();
export const relatedCasesStore = new RelatedCasesStore();
export const calculatorState = new Calculator();
export const searchStore = new SearchStore();

export { observer } from 'mobx-react-lite';
